import { useEffect } from "react";
import DataTable from "react-data-table-component";
import { customStyles } from "../../../util/TableStyles"
import { noDataComponent } from "../../../util/DataObject"
import { useCustomerFeatures } from "./hooks/useCustomerFeatures";

import { CustomerFeaturesProps } from "./types";
import { FlexGrid, Button, Typography, useThemeProvider, Card, Skeleton, Separator } from '@albo-ui/core'
import { IconButton, MenuItem, TextField } from "@mui/material";
import { ManageAccounts, Search, Close, AttachFile } from "@mui/icons-material";


export const MassCustomerBlock = ({ changeAlert, changeLoader }: CustomerFeaturesProps) => {
    
    const { theme } = useThemeProvider();
    const { getCatalog, find, onSelectFile, deleteCustomer, onSelectReason, send, changeText, addComment, columns, loading: loadingTable, active, disabled, catalog, search, list, listStatus, disabledAdd, colapse } = useCustomerFeatures(changeAlert)

    const addFile = () => {
        document.getElementById('file').click();  
    }
    const presDown = (e) => {
        if (e.key === "Enter") {
          find();
        }
    };

    useEffect(() => {
        changeLoader(loadingTable)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadingTable])
    useEffect(() => {
        getCatalog('block')
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    
    return (
        <Card padding={4} flexDirection="column" fullWidth fullHeight alignItems="stretch" justifyContent="space-between" style={{ borderColor: theme.colors.manatee, margin: 3 }}> 
            <FlexGrid container fullWidth justify="space-between" >
                <FlexGrid item>
                    <Typography variant="h2" style={{display: "inline-flex", alignItems: "center", fontSize: "1.2rem"}}>
                        <ManageAccounts sx={{ marginRight: 1 }}/> Bloqueo Masivo de Clientes
					</Typography>
                </FlexGrid>
                <FlexGrid item>
                    <IconButton onClick={addFile.bind(this, "")} sx={{paddingTop: "0 !important"}}>
                    <AttachFile titleAccess="Agregar desde csv"/>
                    <input type="file" accept="text/csv" style={{display: 'none'}} id="file" onChange={onSelectFile.bind(this)} />
                    </IconButton>
                </FlexGrid>
            </FlexGrid>

            <FlexGrid container spacing={2} style={{margin: '25px 0', width: "50%" }}>
                <TextField
                    label="Ingresa un dato del cliente: Email, No. celular, CLABE, etc."
                    value={search} onChange={changeText.bind(this)} color="secondary" size="small" fullWidth
                    onKeyDown={!search ? presDown(false) : presDown.bind(this)}
                    InputProps={{
                        endAdornment: (
                            <IconButton disabled={!search} onClick={find.bind(this)}>
                                <Search cursor={"pointer"} />
                            </IconButton>
                        ),
                    }}
                />
            </FlexGrid>

            { Object.keys(list).length > 0 && 
                <FlexGrid item >
                    <Separator orientation="horizontal" style={{minHeight: 2, maxHeight: 2}} />
                    <FlexGrid container fullWidth justify="space-between" style={{fontWeight: "bolder", margin: "1rem 0" }}>
                        <FlexGrid item >
                            Seleccione el/los usuario/s a bloquear:
                        </FlexGrid>
                        <FlexGrid item >
                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                            <a href="#" onClick={colapse.bind(this, false)}><h4>{active ? "Ocultar listado" : "Ver listado"}</h4></a>
                        </FlexGrid>
                    </FlexGrid>
                    
                    {active &&
                        <FlexGrid container spacing={2} style={{margin: '25px 0' }}>
                        {
                            loadingTable ?
                                <Skeleton width="100%" height="100px" />
                                :
                                <DataTable columns={columns} data={list} customStyles={customStyles} noDataComponent={noDataComponent} />

                        }
                        </FlexGrid>
                    }
                </FlexGrid>
            }
            { listStatus.length > 0 && 
              <FlexGrid item style={{fontWeight: "bolder", marginBottom: "1rem"}}>
                <hr />Lista a Cancelar, <span style={{ color: "#3743aa", fontStyle: "italic"}}>{listStatus.length} {"cliente(s)"}.</span> {disabledAdd ? <span style={{ color: "red", fontStyle: "italic"}}>Límite de usuarios alcanzado. Máximo 50</span> : null}
              </FlexGrid>
            }

            { listStatus.length > 0 && listStatus.map((item, index) => {
                return (
                    <FlexGrid container fullWidth alignItems="center" spacing={2} key={index} style={{marginBottom: "10px"}}> 
                        <FlexGrid item style={{width: "4%"}}>
                            <Close titleAccess={`Eliminar de \nla lista`} onClick={() => deleteCustomer(item.customer.uuid)} cursor={"pointer"}/>
                        </FlexGrid>                 
                        <FlexGrid item style={{fontSize: "18px !important", width: "30%"}}>
                            {item.customer.name}
                        </FlexGrid>
                        <FlexGrid item style={{width: "36%"}}>
                            <TextField label="Motivo" value={item.reason || ""} onChange={(e)=>{onSelectReason(e, item.customer.uuid)}} select size="small" fullWidth color="secondary">
                                <MenuItem value="" disabled>Selecione</MenuItem>
                                {catalog?.map((item, index) => (
                                    <MenuItem key={`cancel-option-${index}`} value={item["k"]}>{item["v"]}</MenuItem>
                                ))}
                            </TextField>
                        </FlexGrid>
                        <FlexGrid item style={{width: "30%"}}>
                            <TextField label="Comentarios" value={item.comment || ""} onChange={(e)=>{addComment(e, item.customer.uuid)}} size="small" fullWidth color="secondary" />
                        </FlexGrid>
                    </FlexGrid>
                )
            })}

            <FlexGrid style={{alignSelf: "end", marginTop: "2rem"}}>
                <Button disabled={disabled} size='normal' onClick={send}>
                    Aceptar
                </Button>
            </FlexGrid>            
        </Card>
    )
}

